import './schema-builder.css';

import { FormRenderer } from '@wegolook/schema-form-renderer';
import React, { Component } from 'react';

class SchemaBuilderContext extends Component {
  render() {
    return (
      <FormRenderer
        {...this.props}
        schema={this.props.editSchemaSchema}
        formValue={this.props.editSchemaPreview}
        onChange={this.props.onChange}
        renderContext="schema-builder"
      />
    );
  }
}

export default SchemaBuilderContext;
